import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Drawer, Tooltip } from '@h3/antd-vue';
import getDownloadUrlNew from '../../../../../../common/src/utils/getDownloadUrlNew';
let CommonDrawer = class CommonDrawer extends Vue {
    constructor() {
        super(...arguments);
        this.isShowModal = false;
        this.userInfo = {};
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem('token');
    }
    getDownloadUrl(refId) {
        let url = `${this.apiHost}/api/aliyun/download?refId=${getDownloadUrlNew.getRefId(refId)}`;
        if (this.token) {
            url += '&T=' + this.token;
        }
        return url;
    }
    onClose() {
        this.$emit('input', false);
    }
    onValueChange(v) {
        this.isShowModal = v;
    }
    onDataChange(v) {
        const keys = Object.keys(v);
        keys.forEach((k) => {
            v[k] = v[k] || '--';
        });
        this.userInfo = v;
    }
};
tslib_1.__decorate([
    Prop()
], CommonDrawer.prototype, "value", void 0);
tslib_1.__decorate([
    Prop()
], CommonDrawer.prototype, "data", void 0);
tslib_1.__decorate([
    Watch('value')
], CommonDrawer.prototype, "onValueChange", null);
tslib_1.__decorate([
    Watch('data')
], CommonDrawer.prototype, "onDataChange", null);
CommonDrawer = tslib_1.__decorate([
    Component({
        name: 'CommonDrawer',
        components: {
            ADrawer: Drawer,
            ATooltip: Tooltip,
        }
    })
], CommonDrawer);
export default CommonDrawer;
